<template>
  <q-layout view="hHh lpR fFf">
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script setup>
import { onMounted } from 'vue';
import { useAuthStore } from './stores/auth';

const authStore = useAuthStore();

// ✅ Call `init()` instead of `fetchUser`
onMounted(async () => {
  try {
    await authStore.init();
  } catch (error) {
    console.error('Error initializing auth:', error);
  }
});
</script>